<div class="row-layout-track-left-align upgrade-module-large-card-area" id="module-card-area">
    <div class="largecard-layout-box__50">
        <mat-card class="card" id="leftCard">
            <div class="card-content">
                <div>
                    <div class="left-card-headline">
                        {{ headline }}
                    </div>
                    <p>{{ shortOverview }}</p>
                    <div>
                        <button id="learnMoreButton" class="mat-button">Learn More</button>
                        <button class="mat-button mat-button--raised">Upgrade</button>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>

    <div class="largecard-layout-box__50">
        <mat-card class="card" id="rightCard">
            <div class="card-content">
                <div>
                    <div class="right-card-headline">
                        {{ selligPointHeader }}
                    </div>
                    <img src="{{ logoPlaceholder }}" />
                    <p>{{ moduleShortDescription }}</p>
                    <p *ngIf="showCompensafelink">
                        <a href="http://www.lbaware.com/">Schedule a Demo Today!</a>
                    </p>
                </div>
            </div>
        </mat-card>
    </div>
</div>
